module.exports = __webpack_public_path__ + "img/imac-3.1252c3a8.jpeg";